import { createStyles, getStylesRef } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    overflowX: "auto",
    backgroundColor: "var(--app-bg)",
  },
  btn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
    marginTop: 50,
    backgroundColor: "var(--app-surface)",
    padding: "1rem",
    borderRadius: "10px",
    "@media (max-width: 480px)": {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "10px",
      padding: "12px",
    },
  },
  rightBTN: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    "& .mantine-Menu-dropdown": {
      padding: "0 !important",
    },
    "@media (max-width: 480px)": {
      flexWrap: "wrap",
      gap: "8px",
    },
  },
  mymodal: {
    width: "min(818px, 95vw)",
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
  },
  mwd: {
    width: "100%",
  },
  table: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    borderRadius: "16px",
    background: "var(--app-surface)",
    padding: "12px 8px",
    gap: 12,
    marginBlock: 30,
  },
  pagination: {
    margin: "1rem 0",
    display: "flex",
    alignItems: "end",
    justifyContent: "end",
  },
  btnIcon: {
    ref: getStylesRef("btnIcon"),
    background: "var(--app-primary)",
    borderRadius: 5,
    cursor: "pointer",
  },
  FilterIcon: {
    // background: "#FFBA45",
    padding: "5px",
    borderRadius: 3,
    cursor: "pointer",
  },
  titleText: {
    color: "var(--app-text)",
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px", // 150%
  },
  filterMenu: {
    padding: "0 !important",
    "& .mantine-Menu-dropdown": {
      padding: "0 !important",
    },
  },
  notesFilterBox: {
    borderRadius: "16px",
    "& .header": {
      padding: "13px 19px",
      borderRadius: "16px 16px 0px 0px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: "var(--app-surface)",
      "& .mantine-Text-root": {
        color: "var(--app-text)",
        fontFamily: "Inter",
        fontSize: "24px",
        fontWeight: "700",
      },
      "& button": {
        padding: "0px",
      },
    },
    "& .filterBody": {
      backgroundColor: "var(--app-bg)",
      padding: "12px 12px 30px 12px",
      display: "flex",
      flexDirection: "column",
      gap: 7,
      "& .fieldParent": {
        padding: "12px",
        borderRadius: "8px",
        border: "1px solid var(--app-border)",
        background: "var(--app-surface)",
        "& .datePicker": {
          fontFamily: "Inter",
          "& .mantine-InputWrapper-label": {
            color: "var(--app-text)",
            fontFamily: "Inter",
            fontSize: "14px",
            fontWeight: 500,
          },
          "& .mantine-Input-wrapper": {
            marginTop: "8px",
            backgroundColor: "var(--app-surface)",
            borderRadius: "8px",
            border: "1px solid var(--app-border)",
            boxShadow:
              "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px var(--app-surface-2)",

            "& .mantine-DatePickerInput-input": {
              paddingBlock: "10px",
              height: "auto",
              color: "var(--app-text)",
              fontFamily: "Inter",
              fontSize: "14px",
              fontWeight: 600,
            },
          },
        },
      },
    },
    "& .boxFooter": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "18px 15px",
      borderTop: "1px solid var(--app-border)",
      borderRadius: "0px 0px 16px 16px",
      background: "var(--app-surface)",
      "& button": {
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        borderRadius: "8px",
        padding: "8px 14px",
        height: "auto",
        fontSize: "14px",
        fontWeight: 600,
        lineHeight: "20px",
        fontFamily: "Inter",
      },
      "& .resetBtn": {
        backgroundColor: "var(--app-surface-2)",
        border: "1px solid var(--app-border)",
        color: "var(--app-text)",
      },
      "& .applyBtn": {
        backgroundColor: "var(--app-text)",
        border: "1px solid var(--app-text)",
        color: "var(--app-surface)",
      },
    },
  },
  searchInput: {
    width: "55%",
    height: "auto",
    backgroundColor: "var(--app-surface)",
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    "& .mantine-Input-input": {
      fontFamily: "Inter",
      border: "none",
      backgroundColor: "transparent",
      height: "44px",
    },
    "@media (max-width: 480px)": {
      width: "100%",
    },
  },
  box_header: {
    display: "flex",
    justifyContent: "space-between",
    padding: "16px 15px"
  }, 
  box_body: {
    display: "flex",
    flexDirection: "column",
    rowGap: "10px",
    background: "var(--app-bg)",
    padding: "15px",
    borderTop: "1px solid var(--app-border)",
    borderBottom: "1px solid var(--app-border)",
    // "& .filterFields": {
    //   padding: "12px"
    // }
  },
  filterFields: {
    padding: "12px",
    background: "var(--app-surface)",
    border: "1px solid var(--app-border)",
    borderRadius: "8px"
  },
  btn_container: {
    display: "flex",
    justifyContent: "space-between",
    padding: "16px 15px"
  },
  search_container: {
    backgroundColor: "var(--app-surface)",
    padding: "1rem",
  },
  filterCategoryList: {
    display: "flex",
    flexDirection: "column",
    gap: 0,
  },
  filterCategoryItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 15px",
    cursor: "pointer",
    borderBottom: "1px solid var(--app-border)",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    color: "var(--app-text)",
    "&:hover": {
      backgroundColor: "var(--app-surface-2)",
    },
  },
  activeFilterDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "var(--app-primary)",
  },
  filterCategoryHeader: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "16px 15px",
    borderBottom: "1px solid var(--app-border)",
    cursor: "pointer",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 600,
    color: "var(--app-text)",
  },
  activeFiltersBar: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 8,
    backgroundColor: "var(--app-surface)",
    padding: "8px 2rem",
    "@media (max-width: 480px)": {
      padding: "8px 12px",
    },
  },
  filterChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "4px 10px",
    borderRadius: "16px",
    backgroundColor: "var(--app-surface-2)",
    border: "1px solid var(--app-border)",
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 500,
    color: "var(--app-text)",
    "& svg": {
      cursor: "pointer",
      color: "var(--app-text-muted)",
      "&:hover": {
        color: "var(--app-text)",
      },
    },
  },
  clearAllLink: {
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 500,
    color: "var(--app-primary)",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

export default useStyles;
